import React, { useState, useEffect, useContext } from 'react'
import Cookies from 'js-cookie'
import CookieBanner from './components/layout/CookieBanner'
import { loadScript } from './utils/scriptLoader'
import useApi from './templates/useApi'
export const applicationContext = React.createContext()
const PP_SDK_URL = 'https://www.paypal.com/sdk/js?client-id=sb'

const Provider = ({ children }) => {
  const [user, setUser] = useState({})
  const [isScriptLoaded, setScriptLoaded] = useState(false)
  const [isPPSDKLoaded, setPPSDKLoaded] = useState(false)
  const [countrySelection, setCountrySelection] = useState('US')
  const [cookieBanner, setCookieBanner] = useState({})
  const [isInternalUser, setInternalUser] = useState(false)
  const [rightNav, _setRightNav] = useState()
  const elmoData = useApi('/apis/elmodata')

  const setRightNav = (nav) => {
    _setRightNav(nav)
  }

  // We had been just using setUser to update state whenever we fetched user
  // data from /apis/user, but we'd also like to update FPTI `cust` property
  // in addition to the user data stored in state. This `updateUser` function
  // allows us to both, and it's this function that we pass down to children
  // as setUser via the Provider value
  const updateUser = (data = {}) => {
    // Sets user data in state which can be consumed by children components who
    // wrap themselves with this <Provider />
    setUser(data)

    // If the user is logged in, we will have their encrypted account number
    const { encryptedAccountNumber } = data

    // If we have an encrypted account number, and if pa.js (FPTI) has already
    // been loaded, then we can just set the `cust` so that it will be
    // populated for all subsequent FPTI events
    if (encryptedAccountNumber && window && window.fpti) {
      window.fpti.cust = encryptedAccountNumber

      // If pa.js/FPTI has not yet loaded, let's set an event listener, which
      // is set up to be fired when pa.js loads (in dx-analytics.js), and then
      // update the cust property then
    } else if (encryptedAccountNumber) {
      window.addEventListener('paLoaded', async () => {
        window.fpti.cust = encryptedAccountNumber
      })
    }
  }

  const updateCountrySelection = (country) => {
    setCountrySelection(country)
  }

  useEffect(() => {
    ;(async function () {
      // TODO: we likely don't need to fetch user data here bc we're already
      // doing so in the <Layout /> component, which is rendered on every
      // page load. Also, this useEffect function is likely being called twice,
      // once on initial page load and once when `elmoData` loads/changes
      if (window && window.app) {
        setScriptLoaded(true)
      } else {
        window.addEventListener('scriptLoad', async () => {
          setScriptLoaded(true)
        })
      }
      try {
        if (!isPPSDKLoaded) {
          await loadScript({ src: PP_SDK_URL })
          setPPSDKLoaded(true)
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('unable to load PayPal SDK')
      }
    })()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elmoData])

  useEffect(() => {
    let cookieBannerInfo =
      typeof window !== `undefined` &&
      window.__INITIALDATA__ &&
      window.__INITIALDATA__.cookieBannerInfo
    setCookieBanner(cookieBannerInfo)

    let isInternalRequest =
      typeof window !== `undefined` &&
      window.__INITIALDATA__ &&
      window.__INITIALDATA__.isInternalUser
    setInternalUser(isInternalRequest)
  }, [])

  //add elmo data to pass on
  return (
    <applicationContext.Provider
      value={{
        user,
        setUser: updateUser,
        isInternalUser,
        isScriptLoaded,
        isPPSDKLoaded,
        setPPSDKLoaded,
        countrySelection,
        updateCountrySelection,
        elmoData,
        Cookies,
        rightNav,
        setRightNav,
      }}
    >
      {children}
      <CookieBanner cookieBannerInfo={cookieBanner} />
    </applicationContext.Provider>
  )
}

const ProviderComponent = ({ element }) => <Provider>{element}</Provider>

export default ProviderComponent

export const useApplicationContext = () => useContext(applicationContext)